/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Global styles for the app 
Author: Deimos Space UK

Version: 1.0
*/
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Estilos globales */
  body {
    font-family: 'Arial', sans-serif; /* Establece la fuente Arial como fuente global */
    margin: 0;
    padding: 0;
    /* Otros estilos para el body si lo deseas */
  }

  /* Otros estilos globales que desees aplicar a tus componentes */
`;

export default GlobalStyles;